import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Box,
} from '@mui/material';
import {
  Warning,
  Delete,
} from '@mui/icons-material';

const CustomToolDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  toolConfig,
  isDeleting = false,
  isDefinition = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="error" />
        Delete {isDefinition ? 'Custom Tool Definition' : 'Custom Tool Configuration'}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete {isDefinition ? 'the tool definition' : 'the configuration'} <strong>"{toolConfig?.name || toolConfig?.tool_name}"</strong>?
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> This action will permanently delete the custom tool {isDefinition ? 'definition. This might affect agents using this tool.' : 'configuration.'}
            This action cannot be undone.
          </Typography>
        </Alert>
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            <strong>Tool:</strong> {isDefinition ? toolConfig?.name : (toolConfig?.tool_name || 'N/A')}
          </Typography>
          {!isDefinition && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              <strong>Provider:</strong> {toolConfig?.provider || 'N/A'}
            </Typography>
          )}
          {toolConfig?.description && (
            <Typography variant="body2" color="text.secondary">
              <strong>Description:</strong> {toolConfig.description}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} /> : <Delete />}
        >
          {isDeleting ? 'Deleting...' : 'Delete Configuration'}
        </Button>
      </DialogActions>
    </Dialog >
  );
};

export default CustomToolDeleteDialog;
